import { useTranslation } from 'react-i18next'

import ToolButton from 'js/components/Tiptap/components/ToolButton'
import { useTipTapEditorStore } from 'js/lib/stores'

import ExitFullScreenIcon from 'icons/exit-fullscreen.svg'
import FullScreenIcon from 'icons/fullscreen.svg'

const FullScreenButton = ({ reference }: { reference: string }) => {
    const isFullScreen = useTipTapEditorStore((state) =>
        state.isFullScreenByReference(reference),
    )

    const setIsFullScreen = useTipTapEditorStore(
        (state) => state.setIsFullScreen,
    )

    const { t } = useTranslation()

    const tooltip = isFullScreen
        ? t('full-screen.exit-full-screen')
        : t('full-screen.enter-full-screen')

    const handleClick = () => {
        setIsFullScreen(!isFullScreen, reference)
    }

    return (
        <ToolButton tooltip={tooltip} onClick={handleClick}>
            {isFullScreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
        </ToolButton>
    )
}

export default FullScreenButton
